module.exports = __webpack_public_path__ + "static/media/eyescan11.733d35ec.png";